import api from "@/api/locked_products/locked_products";

const getLockedItems = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .getLockedItems(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
const deleteLockedItems = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .deleteLockedItems(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

export default {
  getLockedItems,
  deleteLockedItems,
};
